var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$wait.is("load_events")
    ? _c("LayoutWithContainer", [
        _c(
          "div",
          { staticClass: "loading" },
          [_c("Spinner", { attrs: { height: 40, width: 40 } })],
          1
        ),
      ])
    : _c(
        "LayoutWithContainer",
        [
          _c(
            "template",
            { slot: "header" },
            [
              _c(
                "ContentHeader",
                { attrs: { title: "Documents" } },
                [
                  _c(
                    "template",
                    { slot: "actions" },
                    [
                      _vm.can("createInsightCategories")
                        ? _c(
                            "router-link",
                            {
                              staticClass: "btn btn--primary",
                              attrs: { to: { name: "create-document" } },
                            },
                            [
                              _vm._v(
                                "\n                    Add Document\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          this.categories && this.categories.length > 0
            ? _c(
                "div",
                { staticClass: "grid grid--cards" },
                _vm._l(this.categories, function (category) {
                  return _c(
                    "div",
                    { staticClass: "col-xs-6" },
                    [
                      _c("Card", {
                        attrs: {
                          url: `/documents/category/${category.id}`,
                          title: category.name,
                          "sub-title": category.description,
                          img: category.image ? category.image.url : null,
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }